import { console, cookie } from 'react-redux-app/lib/modules/core/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';

import { actionChangeLang } from '../../../core/i18n/actions';
import { getCurrentLang } from 'react-redux-app/lib/modules/i18n/selectors';
import { DEFAULT_LANG, availableLangs, LANGUAGE_COOKIE } from '../../../core/i18n/constants';


export default ({ getState, dispatch }) => (
  function checkLangHandler(nextState, successCallback, errorCallback) {
    try {
      const urlLang = nextState.params.lang;
      const currentLang = getCurrentLang(getState());
      const cookieLang = cookie.getCookie(LANGUAGE_COOKIE);

      const nextLang = (
        (availableLangs.includes(urlLang) && urlLang)
        || (availableLangs.includes(cookieLang) && cookieLang)
        || (availableLangs.includes(currentLang) && currentLang)
        || DEFAULT_LANG
      );

      if (nextLang !== urlLang) {
        const { pathname, search, hash } = nextState.location;
        errorCallback(`/${nextLang}${pathname}${search}${hash}`);
        return;
      }

      dispatch(actionChangeLang(nextLang));

      successCallback();
    } catch (e) {
      console.consoleError('checkLangHandler failed', e);
      errorCallback(INTERNAL_ERROR_URI);
    }
  }
);
